import React, { useEffect, useState } from 'react';
import { database } from '../firebaseConfig';
import { ref, get, set, remove } from 'firebase/database';
import { interestKey, interestList } from '../services/nicheNews';

// Profile card: the agent's niche news interests (areas, communities, topics). Stored at users/<uid>/newsInterests.
export default function NewsInterestsSection({ uid, cardStyle, h2Style }) {
  const [items, setItems] = useState([]);
  const [text, setText] = useState('');
  const [err, setErr] = useState('');
  useEffect(() => {
    if (!uid) return;
    get(ref(database, `users/${uid}/newsInterests`)).then((s) => setItems(interestList(s.val()))).catch(() => {});
  }, [uid]);
  const add = async (e) => {
    e.preventDefault();
    const label = text.trim().slice(0, 60);
    const key = interestKey(label);
    if (!key) return;
    if (items.some((i) => i.key === key)) { setErr('You already follow that one.'); return; }
    setErr('');
    try {
      await set(ref(database, `users/${uid}/newsInterests/${key}`), label);
      setItems(interestList(Object.fromEntries([...items.map((i) => [i.key, i.label]), [key, label]])));
      setText('');
    } catch { setErr('Could not save. Please try again.'); }
  };
  const drop = async (key) => {
    try { await remove(ref(database, `users/${uid}/newsInterests/${key}`)); setItems(items.filter((i) => i.key !== key)); }
    catch { setErr('Could not remove. Please try again.'); }
  };
  const chip = { display: 'inline-flex', alignItems: 'center', gap: 6, background: '#f5efe1', border: '1px solid #d8c9a8', borderRadius: 16, padding: '6px 10px', margin: '0 6px 6px 0', fontSize: 14 };
  return (
    <div style={cardStyle} id="news-interests">
      <h2 style={h2Style}>Niche news interests</h2>
      <p style={{ color: '#7f7f7f', fontSize: 14, margin: '0 0 12px' }}>
        Add the areas, communities, and topics you want news about, like Estero, Kingston, new construction, or mortgage rates. Articles refresh every couple of days and show in News for you on your dashboard.
      </p>
      <form onSubmit={add} style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 12 }}>
        <input aria-label="New interest" value={text} maxLength={60} onChange={(e) => setText(e.target.value)} placeholder="Add an interest"
          style={{ flex: '1 1 180px', minWidth: 0, padding: '10px 12px', border: '1px solid #d8c9a8', borderRadius: 6, fontSize: 15 }} />
        <button type="submit" style={{ backgroundColor: '#1a1a1a', color: '#D4AF37', border: 'none', padding: '10px 18px', borderRadius: 6, fontWeight: 600, cursor: 'pointer', fontSize: 15 }}>Add</button>
      </form>
      {err && <p style={{ color: '#b00020', fontSize: 14 }}>{err}</p>}
      <div>
        {items.length === 0 && <p style={{ color: '#7f7f7f', fontSize: 14, margin: 0 }}>No interests yet.</p>}
        {items.map((i) => (
          <span key={i.key} style={chip}>
            {i.label}
            <button type="button" onClick={() => drop(i.key)} aria-label={`Remove ${i.label}`} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#8C6D1F', fontSize: 16, padding: 0, lineHeight: 1 }}>×</button>
          </span>
        ))}
      </div>
    </div>
  );
}
